import update from "immutability-helper";
import { v4 } from "uuid";
import _ from "lodash";

import {
  BOOKING_GOTO_STEP,
  BOOKING_INFO_BOOKING_RESULT_SAVE,
  BOOKING_INFO_GUEST_INFO_CHANGE,
  BOOKING_INFO_GUEST_INFO_INIT,
  BOOKING_INFO_LOAD_STATE,
  BOOKING_INFO_PAYMENT_CHECKOUT_RESET,
  BOOKING_INFO_PAYMENT_CHECKOUT_SAVE,
  BOOKING_INFO_PAYMENT_IDLE,
  BOOKING_INFO_PAYMENT_INTENT_RESET,
  BOOKING_INFO_PAYMENT_INTENT_SAVE,
  BOOKING_INFO_PAYMENT_LOADING,
  BOOKING_INFO_PAYMENT_RESULT_SAVE,
  BOOKING_INFO_REMARKS_CHANGE,
  BOOKING_PREV_STEP,
  BOOKING_INIT_STEP,
} from "../actions/book/types";

import {
  COUNTRIES_INFO_SAVE,
  FEATURED_PACKAGE_SAVE,
  MAINPROMO_ITEMS_SAVE,
  TOUR_DATA_SAVE,
  TOUR_IDLE,
  TOUR_LOADING,
  WEBSITEMETA_IDLE,
  WEBSITEMETA_LOADING,
  WEBSITEMETA_SAVE,
  GUESTPROFILE_SAVE,
  GUESTPROFILE_RESET,
} from "../actions/init/types";

import {
  TOURS_LIST_IDLE,
  TOURS_LIST_LOADING,
  TOURS_LIST_SAVE,
  TOURS_METADATA_SAVE,
  TOUR_SEARCH_FORM_CHANGE,
  TOUR_PRICE_INFO_RESET,
  TOUR_PRICE_INFO_SAVE,
  TOUR_INIT_SEARCH_DATA_SAVE,
  PRICE_SEARCH_FORM_CHANGE,
  PRICE_SEARCH_FORM_IDLE,
  PRICE_SEARCH_FORM_SEARCHING,
  PACKAGES_METADATA_SAVE,
  TOURS_LIST_SET_PRODUCT_TYPE,
  LIST_ORDER_CHANGE,
  TOUR_SEARCH_DATA_SAVE,
  PACKAGE_ACC_POLL_SAVE,
  PACKAGE_FLIGHT_SEARCH_RESULT_SAVE,
  TOUR_SEARCH_INIT_SEARCH_STATUSES,
  PACKAGE_SERVICE_SET_SEARCH_STATUS,
  PACKAGE_TRF_SEARCH_RESULT_SAVE,
  TOUR_PRICE_INFO_LOAD_STATE,
  TOUR_SEARCH_FORM_UPDATE,
  TOUR_SEARCH_FORM_RESET,
  TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE,
} from "../actions/search/types";
import {
  AUTOCOMPLETE_RESET_DATA,
  AUTOCOMPLETE_SAVE_DATA,
} from "../actions/common/types";
import { DateTime } from "luxon";

const WebsiteMetadataInitial = {
  metadata: {},
  destinations: [],
  categories: [],
  duration: [],
  loading: false,
  packagesMetadata: {},
};
export const WebsiteMetadata = (state = WebsiteMetadataInitial, action) => {
  switch (action.type) {
    case WEBSITEMETA_SAVE: {
      const { metadata } = action;
      return { ...state, metadata };
    }
    case WEBSITEMETA_LOADING:
      return { ...state, loading: true };
    case WEBSITEMETA_IDLE:
      return { ...state, loading: false };
    case TOURS_METADATA_SAVE: {
      const { destinations, categories, duration } = action;
      return { ...state, destinations, categories, duration };
    }
    case PACKAGES_METADATA_SAVE: {
      const { services, destinations, durations } = action;
      return {
        ...state,
        packagesMetadata: { services, destinations, durations },
      };
    }
    default:
      return state;
  }
};

const MainPromoItemsInitial = { items: [] };
export const MainPromoItems = (state = MainPromoItemsInitial, action) => {
  switch (action.type) {
    case MAINPROMO_ITEMS_SAVE: {
      const { items } = action;
      return { ...state, items };
    }
    default:
      return state;
  }
};

const FeaturedPackageInitial = {};
export const FeaturedPackage = (state = FeaturedPackageInitial, action) => {
  switch (action.type) {
    case FEATURED_PACKAGE_SAVE: {
      const { pkg } = action;
      return { ...state, ...pkg };
    }
    default:
      return state;
  }
};

const TourDetailsInitial = {
  details: {},
  loading: false,
};
export const TourDetails = (state = TourDetailsInitial, action) => {
  switch (action.type) {
    case TOUR_DATA_SAVE: {
      const { details } = action;
      return { ...state, details };
    }
    case TOUR_LOADING:
      return { ...state, loading: true };
    case TOUR_IDLE:
      return { ...state, loading: false };
    case PACKAGE_ACC_POLL_SAVE: {
      const { dest_order, data } = action;

      return update(state, {
        details: {
          accommodation_data: {
            [dest_order.toString()]: { $set: data },
          },
        },
      });
    }
    case PACKAGE_FLIGHT_SEARCH_RESULT_SAVE: {
      const { dest_order, data } = action;
      const orderKey =
        dest_order.toString() === "0" ? "extremalLeg" : dest_order.toString();

      return update(state, {
        details: {
          transportation_data: {
            flights: {
              [orderKey]: {
                $set: [data],
              },
            },
          },
        },
      });
    }
    case PACKAGE_TRF_SEARCH_RESULT_SAVE: {
      const { dest_order, leg_type, data } = action;

      return update(state, {
        details: {
          transfer_data: {
            [dest_order.toString()]: {
              [leg_type]: {
                $set: data,
              },
            },
          },
        },
      });
    }
    case WEBSITEMETA_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
};

const roomTemplate = { adults: 2, children: 0, children_ages: [] };
const PriceSearchFormInitial = {
  date: null,
  adults: 2,
  children: 0,
  children_ages: [],
  searching: false,
  rooms: [{ ...roomTemplate }],
  flight_origin: "",
};
export const PriceSearchForm = (state = PriceSearchFormInitial, action) => {
  switch (action.type) {
    case PRICE_SEARCH_FORM_CHANGE: {
      const { form } = action;
      return update(state, { $merge: { form } });
    }
    case PRICE_SEARCH_FORM_SEARCHING: {
      return { ...state, searching: true };
    }
    case PRICE_SEARCH_FORM_IDLE: {
      return { ...state, searching: false };
    }
    case TOUR_PRICE_INFO_LOAD_STATE: {
      const { data } = action;
      const {
        search_data: { adults, children },
      } = data;

      return { ...state, adults, children };
    }
    default:
      return state;
  }
};

const TourPriceInfoInitial = {
  price_info: {},
  search_session_info: {},
  search_data: {},
  search_status: {},
  update_status: {}, // Tracks if results for a specific service have been updated
};
export const TourPriceInfo = (state = TourPriceInfoInitial, action) => {
  switch (action.type) {
    case TOUR_PRICE_INFO_SAVE: {
      const { price_info } = action;
      return { ...state, price_info };
    }
    case TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE: {
      const { search_session_info } = action;
      return { ...state, search_session_info };
    }
    case TOUR_PRICE_INFO_LOAD_STATE: {
      const { data } = action;
      return data;
    }
    case TOUR_PRICE_INFO_RESET:
      return TourPriceInfoInitial;
    case TOUR_INIT_SEARCH_DATA_SAVE: {
      const { session_id } = action;
      return { ...state, search_data: { ...state.search_data, session_id } };
    }
    case TOUR_SEARCH_DATA_SAVE: {
      const { search_data } = action;
      return {
        ...state,
        search_data: { ...state.search_data, ...search_data },
      };
    }
    case TOUR_SEARCH_INIT_SEARCH_STATUSES: {
      const { srvs } = action;
      const search_status = {};
      srvs.forEach((srv) => (search_status[srv] = {}));
      return { ...state, search_status };
    }
    case PACKAGE_ACC_POLL_SAVE: {
      const { dest_order, status } = action;
      return update(state, {
        search_status: {
          accommodation: { $set: { [dest_order.toString()]: status } },
        },
        update_status: {
          accommodation: { $set: { [dest_order.toString()]: true } },
        },
      });
    }
    case PACKAGE_FLIGHT_SEARCH_RESULT_SAVE: {
      const { dest_order, status } = action;
      return update(state, {
        search_status: {
          flights: { $set: { [dest_order.toString()]: status } },
        },
        update_status: {
          flights: { $set: { [dest_order.toString()]: true } },
        },
      });
    }
    case PACKAGE_SERVICE_SET_SEARCH_STATUS: {
      const { srvType, dest_order, status } = action;
      return update(state, {
        search_status: {
          [srvType]: { $set: { [dest_order.toString()]: status } },
        },
      });
    }
    case PACKAGE_TRF_SEARCH_RESULT_SAVE: {
      const { dest_order, leg_type, status } = action;
      return update(state, {
        search_status: {
          transfers: {
            $apply: (transfers) => ({
              ...transfers,
              [dest_order.toString()]: {
                ..._.get(transfers, dest_order.toString(), {}),
                [leg_type]: status,
              },
            }),
          },
        },
      });
    }
    default:
      return state;
  }
};

export const paxTmp = { adults: 2, children: 0, childrenAges: [] };

export const TourSearchFormInitial = {
  acc_search_type: "dest",
  destination_meta: {},
  destination_code: [],
  categories: [],
  services: [],
  durations: [],
  checkIn: DateTime.now().plus({ days: 1 }).toISODate(),
  checkOut: DateTime.now().plus({ days: 7 }).toISODate(),
  adults: 2,
  children: 0,
  children_ages: [],
  rooms: 1,
};
export const TourSearchForm = (state = TourSearchFormInitial, action) => {
  switch (action.type) {
    case TOUR_SEARCH_FORM_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TOUR_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case TOUR_SEARCH_FORM_RESET: {
      return TourSearchFormInitial;
    }
    default:
      return state;
  }
};

const ToursListInitial = {
  list: [],
  product_type: "PKG",
  loading: false,
  ordering: "price_low_to_high",
};
export const ToursList = (state = ToursListInitial, action) => {
  switch (action.type) {
    case TOURS_LIST_SET_PRODUCT_TYPE: {
      const { product_type } = action;
      return { ...state, list: [], product_type };
    }
    case TOURS_LIST_SAVE: {
      const { list, product_type } = action;
      return { ...state, list, product_type };
    }
    case TOURS_LIST_IDLE:
      return { ...state, loading: false };
    case TOURS_LIST_LOADING:
      return { ...state, loading: true };
    case WEBSITEMETA_LOADING:
      return { ...state, loading: true };
    case LIST_ORDER_CHANGE: {
      const { ordering } = action;
      return { ...state, ordering };
    }
    default:
      return state;
  }
};

const guestTemplate = {
  title: "",
  first_name: "",
  last_name: "",
  email: "",
  group_leader: "",
  room_leader: "",
  gender: "",
  date_of_birth: "",
  identification_code: "",
  identification_expiry_date: "",
  identification_type: "PA",
};

const BookingInformationInitial = {
  guests: {},
  remarks: "",
  execution_date: "",
  tour_reference: null,
  step: 0,
  paymentIntent: {},
  paymentCheckout: {},
  paymentResult: {},
  bookingResult: {},
  loading: false,
  pickup: { name: "" },
  address: "",
};
export const BookingInformation = (
  state = BookingInformationInitial,
  action
) => {
  function initGuests({ adults, children }) {
    return {
      ...state,
      remarks: "",
      pickup: { name: "" },
      address: "",
      guests: {
        adults: new Array(adults).fill(1).map((id, idx) => {
          const g = _.cloneDeep(guestTemplate);
          g["group_leader"] = idx === 0;
          g["room_leader"] = idx === 0;
          g["date_of_birth"] = DateTime.now().minus({ years: 12 }).toISODate();

          return { ...g, uid: v4(), guest_type: "ADT" };
        }),
        children: new Array(children).fill(1).map(() => ({
          ..._.omit(_.cloneDeep(guestTemplate), [
            "email",
            "room_leader",
            "group_leader",
            "title",
          ]),
          uid: v4(),
          guest_type: "CHD",
        })),
      },
    };
  }

  switch (action.type) {
    case BOOKING_PREV_STEP:
      return { ...state, step: state.step - 1 };
    case BOOKING_INIT_STEP: {
      return BookingInformationInitial;
    }
    case BOOKING_GOTO_STEP: {
      const { step } = action;

      state = { ...state, step };
      if (step === 2) {
        state = { ...state, pickup: { name: "" }, address: "" };
      }

      return state;
    }
    case BOOKING_INFO_GUEST_INFO_INIT: {
      const { adults, children } = action;
      return initGuests({ adults, children });
    }
    case BOOKING_INFO_GUEST_INFO_CHANGE: {
      const { uid, formValue, travellerType } = action;
      const gKey = travellerType === "adult" ? "adults" : "children";

      return {
        ...state,
        guests: {
          ...state.guests,
          [gKey]: state.guests[gKey].map((guest) =>
            guest.uid === uid ? formValue : { ...guest }
          ),
        },
      };
    }
    case BOOKING_INFO_REMARKS_CHANGE: {
      const { remarks, pickup, address } = action;

      return { ...state, remarks, pickup, address };
    }
    case BOOKING_INFO_PAYMENT_INTENT_SAVE: {
      const { paymentIntent } = action;
      return { ...state, paymentIntent };
    }
    case BOOKING_INFO_PAYMENT_CHECKOUT_SAVE: {
      const { paymentCheckout } = action;
      return { ...state, paymentCheckout };
    }
    case BOOKING_INFO_PAYMENT_CHECKOUT_RESET: {
      return { ...state, paymentCheckout: {}, paymentResult: {} };
    }
    case BOOKING_INFO_PAYMENT_LOADING:
      return { ...state, loading: true };
    case BOOKING_INFO_PAYMENT_IDLE: {
      return { ...state, loading: false };
    }
    case BOOKING_INFO_PAYMENT_INTENT_RESET:
      return { ...state, paymentIntent: {}, paymentResult: {} };
    case BOOKING_INFO_PAYMENT_RESULT_SAVE: {
      const { paymentResult } = action;
      return { ...state, paymentResult };
    }
    case BOOKING_INFO_BOOKING_RESULT_SAVE: {
      const { bookingResult } = action;
      return { ...state, bookingResult };
    }
    case BOOKING_INFO_LOAD_STATE: {
      const { data } = action;
      return data;
    }
    case TOUR_PRICE_INFO_LOAD_STATE: {
      const { data } = action;
      const {
        search_data: { adults, children },
      } = data;

      var newState = initGuests({ adults, children });
      // If the product is On Request go straight to the guest information page
      return _.get(data, "price_info.booking_mode") === "RQ"
        ? update(newState, { step: { $set: 1 } })
        : newState;
    }
    default:
      return state;
  }
};

const AutocompleteDataInitial = [];
export const AutocompleteData = (state = AutocompleteDataInitial, action) => {
  switch (action.type) {
    case AUTOCOMPLETE_RESET_DATA:
      return AutocompleteDataInitial;
    case AUTOCOMPLETE_SAVE_DATA: {
      const { data } = action;
      return data;
    }
    default:
      return state;
  }
};

export const CountriesInfo = (state = {}, action) => {
  switch (action.type) {
    case COUNTRIES_INFO_SAVE: {
      const { country_info } = action;
      return { ...state, ...country_info };
    }
    default:
      return state;
  }
};

const GuestProfileInitial = {};
export const GuestProfile = (state = GuestProfileInitial, action) => {
  switch (action.type) {
    case GUESTPROFILE_RESET:
      return GuestProfileInitial;
    case GUESTPROFILE_SAVE: {
      const { guestProfile } = action;
      return { ...state, ...guestProfile };
    }
    default:
      return state;
  }
};

export * from "./hotels";
export * from "./flights";
export * from "./restaurants";
export * from "./barclays";
export * from "./activities";
export * from "./transfers";
export * from "./carRental";
export * from "./trains";
export * from "./ferries";
export * from "./sessionIds";
